// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Admin } from './admin';
import { AdminRole } from './admin-role';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class UserAdminRole extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  userAdminRoleId!: number;
  adminId!: number;
  adminRoleId!: number;
  createdBy!: string;
  createdDate!: Date;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  userId!: number;
  admin!: Admin;
  adminRole!: AdminRole;
  user!: User;
}

